import { Auth } from 'aws-amplify';
import type { AxiosError, RawAxiosRequestHeaders } from 'axios';
import Axios from 'axios';
import config from 'config';
import handleAPIPermissionError from 'utils/handleAPIPermissionError';
import queryString from 'query-string';
import { AppError } from '../error';

const getAuthorizationHeader = async () => `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`;

const apiClient = Axios.create({
  baseURL: config.ADMIN_API_URL,
  headers: { 'x-API-key': config.ADMIN_API_KEY } as RawAxiosRequestHeaders,
  paramsSerializer: (prms) => queryString.stringify(prms, { arrayFormat: 'comma' }),
});

apiClient.interceptors.request.use(async (cfg) => {
  cfg.headers.set('Authorization', await getAuthorizationHeader());
  return cfg;
});

apiClient.interceptors.response.use(
  (cfg) => {
    return cfg;
  },
  (error: AxiosError) => {
    if (error.response?.status === 403) {
      handleAPIPermissionError(error);
    }

    return Promise.reject(new AppError(error));
  }
);

export default apiClient;
